import {deserialize, deserializeAs} from "cerialize";

export default class Plot{
    constructor(description:string) {
        this.description = description;
    }

    @deserializeAs("ref")
    id: number;

    @deserialize
    description: string;

    @deserialize
    alias: string;

    @deserialize
    area: number;

    @deserialize
    farm: number;

    @deserialize
    harvest: number;
}
